import React, { Component } from "react";
import ReactGA from "react-ga";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Distance from "./Distance";
import YesNo from "./YesNo";
import Location from "./Location";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import StepperGroup from "./StepperGroup";
import "rc-slider/assets/index.css";
// import BikeNodes from "../atoms/BikeNodes";
import BikeNodeNav from "./BikeNodeNav";
import Button from "@material-ui/core/Button";
import BikeNodesApi from "./BikeNodesApi";

const styles = theme => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "center"
  },
  bikeNodesWrapper: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  bikeNodesMessage: {
    paddingBottom: "1em"
  },
  bikeNodes: { display: "inline-block" },
  // activeStepContainer: {
  //   // height: "100%",
  //   // display: "flex",
  //   // flexDirection: "column",
  //   // justifyContent: "center",
  //   marginBottom: "56px",
  //   overflow: "auto"
  // },
  newRouteButton: {
    margin: "2em 0 6em 0"
  },
  ctiveStep: {
    textAlign: "center"
  },
  skipAll: {
    textAlign: "center",
    margin: "10px 0"
  },
  StepperGroup: {
    // position: "fixed",
    // width: "100%",
    // bottom: "56px"
    // marginBottom: "56px"
  }
});

const bikeNodesStep = 4;

function SkipAll(props) {
  const { activeStep, classes, onClick } = props;
  if (activeStep > 1 && activeStep < bikeNodesStep) {
    return (
      <Button variant="raised" className={classes.button} onClick={onClick}>
        Geef mij maar al een route
      </Button>
    );
  }
  return null;
}

SkipAll.propTypes = {
  activeStep: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

function BikeNodesWrapper(props) {
  const { classes, geojson, reset, activeNodeIndex } = props;
  return (
    <div className={classes.bikeNodesWrapper}>
      <div className={classes.bikeNodes}>
        <BikeNodeNav
          geojson={geojson}
          activeNodeIndex={activeNodeIndex}
          type="generated"
          reset={reset}
        />
      </div>
    </div>
  );
}

BikeNodesWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  geojson: PropTypes.object.isRequired,
  reset: PropTypes.func.isRequired,
  activeNodeIndex: PropTypes.number
};

const initialState = {
  activeStep: 0,
  water: false,
  showModal: false,
  // geoLocationWatchId: null,
  geojson: {}
};

const currentVersion = 5;

class Home extends Component {
  state = initialState;

  constructor(props) {
    super(props);
    try {
      const version = localStorage.getItem("version");
      if (version === undefined || version < currentVersion) {
        localStorage.setItem("version", currentVersion);
        throw new Error("Old version");
      }

      ["distance", "startLocation", "offroad", "cobble"].forEach(parameter => {
        // this.setState({[parameter]: JSON.parse(localStorage.getItem(parameter))}
        this.state[parameter] = JSON.parse(localStorage.getItem(parameter));
      });

      const geojson = JSON.parse(localStorage.getItem("generatedgeojson"));
      const activeNodeIndex = JSON.parse(
        localStorage.getItem("generatedactiveNode")
      );
      if (geojson.pois === undefined || geojson.features === undefined) {
        throw new Error("invalid geojson stored");
      }
      if (geojson && Number.isInteger(activeNodeIndex)) {
        // this.setState({ geojson, activeStep: bikeNodesStep, activeNodeIndex });
        this.state.geojson = geojson;
        this.state.activeStep = bikeNodesStep;
        this.state.activeNodeIndex = activeNodeIndex;
      }
    } catch (err) {
      // console.error(err)
      localStorage.removeItem("generatedgeojson");
      localStorage.removeItem("generatedactiveNode");
    }
  }

  // componentDidMount() {
  //   try {
  //     const version = localStorage.getItem("version");
  //     if (version === undefined || version < currentVersion) {
  //       localStorage.setItem("version", currentVersion);
  //       throw new Error("Old version");
  //     }

  //     this.loadSavedParameters(["distance","startLocation","offroad","cobble"])

  //     const geojson = JSON.parse(localStorage.getItem("generatedgeojson"));
  //     const activeNodeIndex = JSON.parse(
  //       localStorage.getItem("generatedactiveNode")
  //     );
  //     if (geojson.pois === undefined || geojson.features === undefined) {
  //       throw new Error("invalid geojson stored");
  //     }
  //     if (geojson && Number.isInteger(activeNodeIndex)) {
  //       this.setState({ geojson, activeStep: bikeNodesStep, activeNodeIndex });
  //     }
  //   } catch (_) {
  //     localStorage.removeItem("generatedgeojson");
  //     localStorage.removeItem("generatedactiveNode");
  //   }
  // }

  skipAll = () => {
    // this.startGeoTracking();
    this.setState({ activeStep: bikeNodesStep });
  };

  addStep = () => {
    // this.startGeoTracking();
    this.setState(state => {
      const { activeStep } = state;
      return { activeStep: activeStep + 1 };
    });
  };

  callbackSetState = (key, value) => {
    let object = {};
    object[key] = value;
    localStorage.setItem(key, JSON.stringify(value));
    this.setState(object);
    this.addStep();
  };

  showResetModal = () => {
    this.setState({ showModal: true });
  };

  reset = () => {
    ReactGA.event({
      category: "Route",
      action: "Generate new route, new parameters"
    });
    localStorage.removeItem("generatedgeojson");
    localStorage.removeItem("generatedactiveNode");
    this.setState({
      activeStep: 0,
      water: false,
      showModal: false,
      // geoLocationWatchId: null,
      geojson: {}
    });
  };

  regen = () => {
    ReactGA.event({
      category: "Route",
      action: "Generate new route, same parameters"
    });
    localStorage.removeItem("generatedgeojson");
    localStorage.removeItem("generatedactiveNode");

    this.setState({
      activeStep: 4,
      geojson: {},
      error: null
    });
  };

  handleClose = shouldReset => {
    switch (shouldReset) {
      default:
      case "closeModal":
        break;
      case "sameParameters":
        this.regen();
        break;
      case "newParameters":
        this.reset();
        break;
    }
    this.setState({ showModal: false });
  };

  // function ShowActiveStep(props) {
  ShowActiveStep = () => {
    const { activeStep, geojson, activeNodeIndex } = this.state;
    const { classes } = this.props;

    const callback = this.callbackSetState;
    const reset = this.showResetModal;
    const parameters = this.state;

    let routesGenerated = localStorage.getItem("routesGenerated");
    if (routesGenerated === null) {
      routesGenerated = 0;
    } else {
      routesGenerated = parseInt(routesGenerated, 10);
    }

    switch (activeStep) {
      default:
        return null;
      case 0:
        return <Distance callback={callback} />;
      case 1:
        localStorage.setItem("routesGenerated", routesGenerated + 1);
        return <Location callback={callback} />;
      case 2:
        return (
          <YesNo
            title="Wil je zandwegen vermijden?"
            callback={callback}
            setKey="offroad"
          />
        );
      case 3:
        return (
          <YesNo
            title="Wil je kasseiwegen vermijden?"
            callback={callback}
            setKey="cobble"
          />
        );
      case bikeNodesStep:
        if (
          geojson &&
          geojson.pois !== undefined &&
          Number.isInteger(activeNodeIndex)
        ) {
          this.setState({ activeStep: bikeNodesStep + 1 });
          // );
        }
        return (
          <BikeNodesApi
            parameters={parameters}
            render={({ isLoading, data, error, errorMessage }) => {
              if (error) {
                this.setState({ activeStep: bikeNodesStep + 1, error });
                return null;
                // return (
                //   <div>
                //     <div>{errorMessage}</div>
                //     <Button
                //       variant="raised"
                //       className={classes.newRouteButton}
                //       onClick={reset}
                //     >
                //       Nieuwe route
                //     </Button>
                //   </div>
                // );
              }
              if (isLoading) {
                return <CircularProgress size={80} thickness={7} />;
              } else {
                this.setState({ activeStep: bikeNodesStep + 1, geojson: data });
                return null;
              }
              // return isLoading ? (
              //   <CircularProgress size={80} thickness={7} />
              // ) : (
              //   <BikeNodesWrapper
              //     classes={classes}
              //     geojson={data}
              //     reset={reset}
              //   />
              // );
            }}
          />
        );
      case bikeNodesStep + 1:
        if (this.state.error) {
          return (
            <div>
              <div>
                Er is geen route gevonden in jouw buurt met die parameters.
              </div>
              <Button
                variant="raised"
                className={classes.newRouteButton}
                onClick={reset}
              >
                Nieuwe route
              </Button>
            </div>
          );
        }
        return (
          <BikeNodesWrapper
            classes={classes}
            geojson={geojson}
            activeNodeIndex={activeNodeIndex}
            reset={reset}
          />
        );
    }
  };

  render() {
    const { classes } = this.props;
    const { activeStep, showModal } = this.state;

    return (
      <div className={classes.root}>
        <div />
        <div className={classes.activeStep}>{this.ShowActiveStep()}</div>
        <div className={classes.skipAll}>
          <SkipAll
            activeStep={activeStep}
            classes={classes}
            onClick={this.skipAll}
          />
        </div>
        <Dialog
          open={showModal}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Nieuwe route</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ben je zeker dat je een nieuwe route wilt maken?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.handleClose("closeModal");
              }}
              color="primary"
            >
              Nee
            </Button>
            <Button
              onClick={() => {
                this.handleClose("newParameters");
              }}
              color="primary"
            >
              Ja, met andere parameters
            </Button>
            <Button
              onClick={() => {
                this.handleClose("sameParameters");
              }}
              color="primary"
            >
              Ja, met dezelfde parameters
            </Button>
          </DialogActions>
        </Dialog>
        {/* <div className={classes.StepperGroup}>
          <StepperGroup callback={this.setStep} activeStep={activeStep} />
        </div> */}
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Home);



// WEBPACK FOOTER //
// ./src/NewRoute/components/Home.js